'use client';
import { API_ROUTES, useApiPrefetch } from '@shared/api-utils';
import type { GamesListResponse } from '@shared/components';
import { useClientConfig } from '@shared/utils';

const GamesPrefetcher = () => {
  const prefetch = useApiPrefetch();
  const { currency, apiLocale } = useClientConfig();

  prefetch.prefetch<GamesListResponse>(API_ROUTES.GAMES.GAMES_LIST.replace(':locale', apiLocale).replace(':currency', currency));

  return null;
};
export { GamesPrefetcher };
